// Dashboard App usage engagement page translations (en-US), loaded into dashboard.usage.engagement by ../en-US.usage.js
module.exports = {
  menu: "Engagement",
  title: "Engagement",
  description: "How much the users use the app.",
  kpis: {
    eventViews: "Events viewed",
    eventsCreated: "Events created",
    eventShares: "Events shared",
    favorites: "Favorites",
    messages: "Messages",
    checkIns: "Check-ins",
    mapClicks: "Map clicks",
    searches: "Searches",
    filterUses: "Filter uses",
  },
  info: {
    eventViews: "Unique event views in the period (each user counts once per event).\nSource: Firebase (event views).",
    eventsCreated: "Events created in the period.\nSource: Firebase (event counters).",
    eventShares: "Events shared in the period.\nSource: Firebase (event counters).",
    favorites: "Times a user marked “I'm going” on an event in the period, while the app does not record favorites with a date.\nSource: Firebase (event counters).",
    messages: "Chat messages sent in the period.\nSource: Firebase (chat messages).",
    checkIns: "Times a user marked “I'm going” on an event in the period, while the app does not record check-ins with a date.\nSource: Firebase (event counters).",
    mapClicks: "Times the map screens were opened in the Android app in the period.\nSource: Google Analytics.",
    searches: "Event searches with a text made in the apps in the period.\nSource: Firebase (search counters).",
    filterUses: "Event searches with a filter made in the apps in the period.\nSource: Firebase (search counters).",
  },
  panels: {
    eventViews: "Events viewed by {gran}",
    eventsCreated: "Events created by {gran}",
    sections: "Use per section — % of the active users",
    sectionsNote: "Active users with an action in each section: open an event (Discover), promote or say “I'm going” (Timeline), follow someone (Profile), send messages (Chat) and create events in the app (Creator).",
    screens: "Average time on each screen",
    screensNote: "Average time per visit, Android app only: the iOS app does not name its screens in Firebase yet.",
  },
  hints: {
    noSource: "not recorded by the app yet",
  },
  sections: {
    discover: "Discover",
    timeline: "Timeline",
    profile: "Profile",
    chat: "Chat",
    creator: "Creator",
  },
  screens: {
    home: "Home (Discover and Timeline)",
    map: "Map",
    event: "Event",
    chat: "Chat",
    profile: "Profile",
    creator: "Creator",
    search: "Search",
  },
  panelInfo: {
    eventViews: "Unique event views in each interval.\nSource: Firebase (event views).",
    eventsCreated: "Events created in each interval.\nSource: Firebase (event counters).",
    sections: "Share of the active users with an action in each section of the app.\nSource: Firebase (the actions: views, promotions, “I'm going”, follows, messages and events created) and Google Analytics (without it, Firebase: activity log sent by the apps) for the active users.",
    screens: "Average time per visit on each screen of the Android app.\nSource: Google Analytics.",
  },
};
